import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ccaa_actions } from "../../store/ccaa_slice";
import { FileUploader } from "react-drag-drop-files";
import { storage } from "../../firebase";
import { ref, getDownloadURL, uploadBytesResumable,listAll,deleteObject } from "firebase/storage";

import {
  Text
} from '@chakra-ui/react';
import { Typography, Alert,Progress } from "antd";

const { Title } = Typography;

function Upcoming_Year_Forecast() {
  //redux functions
  const dispatch = useDispatch();
  const organization_name_store = useSelector(
    (state) => state.ccaa.organization_name_store
  );

  const upcoming_year_forecast_store = useSelector(
    (state) => state.ccaa.upcoming_year_forecast_store
  );
  //file constants

  const upcoming_year_forecast_default_values = {
    organization_name: organization_name_store,
    anticipate_updates: "",
    sugestions_for_ccaa:"",
    general_comments: "",
  };

  const [upcoming_year_forecast_values, setUpcomingYearForecastValues] =React.useState(upcoming_year_forecast_default_values);

  const [fileUploadProgress, setFileUploadProgress] = React.useState({
    "supporting_documentation_file_upcoming": 0
  });
  const [fileUploadStatus, setFileUploadStatus] = React.useState({
    "supporting_documentation_file_upcoming": false
  });
  const upcoming_year_forecast_files = useSelector(state => state.ccaa.upcoming_year_forecast_files);
  const [fileNames, setFileNames] = React.useState({});
  const [updateFileNames, setUpdateFileNames] = React.useState(0);



  const text_input_width = window.innerWidth * 0.5;
  const text_input_height = window.innerHeight * 0.05;

  const handleFormSubmit = (e) => {
    e.preventDefault();
    dispatch(
      ccaa_actions.set_upcoming_year_forecast(upcoming_year_forecast_values)
    );
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (Array.isArray(upcoming_year_forecast_values[name])) {
      if (!upcoming_year_forecast_values[name].includes(value)) {
        setUpcomingYearForecastValues({
          ...upcoming_year_forecast_values,
          [name]: [...upcoming_year_forecast_values[name], value],
        });
      } else {
        setUpcomingYearForecastValues({
          ...upcoming_year_forecast_values,
          [name]: upcoming_year_forecast_values[name].filter(
            (item) => item !== value
          ),
        });
      }
    } else {
      setUpcomingYearForecastValues({
        ...upcoming_year_forecast_values,
        [name]: value,
      });
    }
  };

  useEffect(() => {
    dispatch(
      ccaa_actions.set_upcoming_year_forecast(upcoming_year_forecast_values)
    );
  }, [upcoming_year_forecast_values]);


  useEffect(() => {
    setUpcomingYearForecastValues(upcoming_year_forecast_store);
    setFileNames({
      supporting_documentation_file_upcoming:[]
    })
    handleFirebaseGetAllFiles("supporting_documentation_file_upcoming")
  }, []);

  useEffect(() => {
    setUpdateFileNames(updateFileNames + 1)
  },[fileNames])


  const handleFirebaseUpload = async (e,fileType) => {
    if(e!== null){
      const uploadFileName = e.name;
      const storageRef = ref(storage, `${organization_name_store}/${fileType}/${uploadFileName}`);
      const uploadTask = uploadBytesResumable(storageRef, e);
      setFileUploadStatus({
        ...fileUploadStatus,
        [fileType]: true
      })
      uploadTask.on('state_changed',
        (snapshot) => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setFileUploadProgress({
            ...fileUploadProgress,
            [fileType]: Math.round(progress)
          });
          switch (snapshot.state) {
            case 'paused':
              break;
            case 'running':
              break;
            default:
          }
        }, (error) => {
          switch (error.code) {
            case 'storage/unauthorized':
              // User doesn't have permission to access the object
              break;
            case 'storage/canceled':
              // User canceled the upload
              break;
            case 'storage/unknown':
              // Unknown error occurred, inspect error.serverResponse
              break;
            default:
          }
        }, () => {
          dispatch(ccaa_actions.set_upcoming_year_forecast_files({fileType,fileName:uploadFileName}))
          setUpdateFileNames(updateFileNames + 1)
        }
      );
      }
    }

  const handleFirebaseDeleteFile = async (fileType,fileName) => {
    const fileRef = ref(storage, `${organization_name_store}/${fileType}/${fileName}`);
    await deleteObject(fileRef);
    dispatch(ccaa_actions.remove_upcoming_year_forecast_files({fileType,fileName:fileName,delete:true}))
  }

  const handleFirebaseGetAllFiles = async (fileType) => {
    const listRef = ref(storage, `${organization_name_store}/${fileType}`);
    const fileList = await listAll(listRef).then((res) => {
      res.items.forEach(item => {
        dispatch(ccaa_actions.set_upcoming_year_forecast_files({fileType,fileName:item.name}))
      }
      )
    })
  }

  useEffect(() => {
    setFileNames(upcoming_year_forecast_files);
  },[upcoming_year_forecast_files])

  return (
    <div className="container">
      <>
        <Title className="mt-4" level={3}>
          Upcoming Year Forecast
        </Title>
        <div className="mt-2 mb-2">
          <Alert
            message="Please note your responses are saved automatically"
            type="info"
            showIcon
          />
        </div>
        <form onSubmit={handleFormSubmit}>
          <div className="mt-4 p-4 border-1 border-dark rounded-3 border-background">
            <div className="row">
              <div className="col-flex-util">
                <Title level={4}>
                  {" "}
                  Describe any changes you would like to make to your
                  Certificate of Inclusion or CCAA implementation, if
                  applicable. If necessary, please indicate a timeframe that you
                  would like to discuss these changes with the UIC team.
                </Title>
                <div>
                  <textarea
                    rows={10}
                    width={text_input_width}
                    height={text_input_height}
                    type="text"
                    className="form-control"
                    id="anticipate_updates"
                    placeholder=""
                    name="anticipate_updates"
                    defaultValue={
                      upcoming_year_forecast_store.anticipate_updates
                        ? upcoming_year_forecast_store.anticipate_updates
                        : ""
                    }
                    onBlur={handleInputChange}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 p-4 border-1 border-dark rounded-3 border-background">
            <div className="row">
              <div className="col-flex-util">
                <Title level={4}>
                  Provide any other general comments about your CCAA
                  implementation or this annual report.
                </Title>
                <div>
                  <textarea
                    rows={10}
                    width={text_input_width}
                    height={text_input_height}
                    type="text"
                    className="form-control"
                    id="general_comments"
                    placeholder=""
                    name="general_comments"
                    defaultValue={
                      upcoming_year_forecast_store.general_comments
                        ? upcoming_year_forecast_store.general_comments
                        : ""
                    }
                    onBlur={handleInputChange}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 p-4 border-1 border-dark rounded-3 border-background">
            <div className="row">
              <div className="col-flex-util">
                <Title level={4}>
                  Do you have any suggestions for the Monarch CCAA Program?
                </Title>
                <div>
                  <textarea
                    rows={10}
                    width={text_input_width}
                    height={text_input_height}
                    type="text"
                    className="form-control"
                    id="suggestions_for_ccaa"
                    placeholder=""
                    name="suggestions_for_ccaa"
                    defaultValue={
                      upcoming_year_forecast_store.suggestions_for_ccaa
                        ? upcoming_year_forecast_store.suggestions_for_ccaa
                        : ""
                    }
                    onBlur={handleInputChange}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 mb-4 p-4 border-1 border-dark rounded-3 border-background">
            <div className="row">
              <div className="col-flex-util">
                <Title level={4}>
                  Upload any other supporting documentation you would like to
                  provide (please briefly describe in the comments box above).
                </Title>
                <div>
                  <FileUploader
                    handleChange={(e) => handleFirebaseUpload(e,"supporting_documentation_file_upcoming")}
                    name="supporting_documentation_file_upcoming"
                  />
                                        <div>
                        {fileUploadStatus["supporting_documentation_file_upcoming"]?<Progress percent={fileUploadProgress["supporting_documentation_file_upcoming"]} status={fileUploadStatus} />:''}
                      </div>
                      <div className='mt-2 file-component'>
                        <Text className='mb-2'>Uploaded Files</Text>
                        {(fileNames["supporting_documentation_file_upcoming"]&&updateFileNames)?fileNames["supporting_documentation_file_upcoming"].map((file,index)=>
                        <div className='mt-2 row' key={index}>
                          <Text className='col-10'>{file}</Text>
                          <button className='col-2 btn btn-sm btn-danger' onClick={(e)=>handleFirebaseDeleteFile("supporting_documentation_file_upcoming",file)}>Delete</button>
                        </div>):null}
                      </div>

                </div>
              </div>
            </div>
          </div>
        </form>
      </>
    </div>
  );
}

export default Upcoming_Year_Forecast;
